<template>
    <div class="pt-cats">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <div>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div class="ptc-items">
                    <div class="ptc-item" v-for="ms in list" @click="toSpuDetails(ms.id)">
                        <div style="margin-bottom: 5px">
                            <van-count-down millisecond :time="ms.time" format="DD:HH:mm:ss" >
                                <template v-slot="timeData">
                                    <span class="item">{{(timeData.days*24)+timeData.hours }}</span>:
                                    <span class="item">{{ timeData.minutes }}</span>:
                                    <span class="item">{{ timeData.seconds }}</span>
                                </template>
                            </van-count-down>
                        </div>
                        <img :src="ms.imgUrl"
                             style="border-top-left-radius: 7px;border-top-right-radius: 7px"/>
                        <div style="display: flex;flex-direction: row;margin-top: 5px">
                            <div style="display:flex;flex-direction: column;width: 60%;padding-left: 8px;height: 75px;justify-content:center;">
                                <span style="height: 23px;line-height: 23px;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ms.msName}}</span>
                                <span style="height: 20px;line-height: 20px;font-size: 11px;color:#D2D2D2;text-decoration: line-through;">原价: {{ms.originalPrice}}</span>
                                <span style="height: 20px;line-height: 20px;font-size: 13px;color: #ff4d51">¥: {{ms.spikePrice}}</span>
                            </div>
                            <div style="display:flex;flex-direction: column;align-items: center;justify-content:center;width: 37%;">
                                <van-icon name="shopping-cart-o" style="font-size: 23px;margin-bottom: 2px"/>
                                <span style="font-size: 9px">已售 {{ms.sale}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
    import {getDeptId, getDeptName} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '限时秒杀',
                deptId: '',
                catId: '',
                cats: [],

                active: 0,

                cId: '',
                list: [],
                loading: false,
                finished: false,
                page: 1,
            };
        },
        async created() {
            document.title = getDeptName()
            this.catId = this.$route.params.catId
            this.deptId = getDeptId()
        },
        methods: {
            async onLoad() {
                let currentPage = this.page || 1;
                let data = {
                    deptId: this.deptId,
                    isShow: "0",
                    currentPage
                }
                let res = await this.$get("/spm/getSpmMsPage", data)
                if (res.code == 200) {
                    const count =res.list.length
                    const newList =res.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
            },

            toSpuDetails(id) {
                this.$router.push('/msDetails/' + this.deptId + '/' + id)
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .pt-cats {
        margin: 0 auto;
        height: 100%;
        padding-top: 78px;
    }

    .ptc-bq {
        margin-bottom: 5px;
        width: 100%;
        position: fixed;
        top: 47px;
        z-index: 999;
    }

    .ptc-items {
        display: flex;
        flex-flow: row wrap;
        font-size: 10px;
        padding: 0px 8px;
    }

    .ptc-item {
        box-sizing: border-box;
        margin: 8px 10px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        width: calc((100% - 40px) / 2); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc((100% - 40px) / 2);
        max-width: calc((100% - 40px) / 2);
    }

    .ptc-bq /deep/ .van-tabs--line {
        height: 32px;
    }

    .ptc-bq /deep/ .van-tabs__wrap {
        height: 32px;
    }

    .ptc-bq /deep/ .van-tab--active {
        color: #323233;
        font-weight: 500;
        font-size: 14px;
        width: 100px;
    }
    .item {
        display: inline-block;
        padding: 0px 3px;
        margin-right: 3px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        background-color: #565656;
    }
    .van-count-down {
        color: #323233;
        font-size: 12px;
        line-height: 15px;
    }
</style>
